import { redirect } from '@tanstack/react-router';
import { createServerFn } from '@tanstack/react-start';

import { resolveLocale } from '~/i18n/resolveLocale';
import { LOCALE_COOKIE_NAME, type AppLocale } from '~/utils/i18n';

export const detectAndSetLocale = createServerFn({ method: 'GET' }).handler(
  async () => {
    const { getRequestHeader, setCookie } = await import(
      '@tanstack/react-start/server'
    );

    const cookieHeader = getRequestHeader('cookie') ?? '';
    const acceptLanguageHeader = getRequestHeader('accept-language') ?? '';

    const { locale, shouldSetCookie } = resolveLocale({
      cookieHeader,
      acceptLanguageHeader,
    });

    if (shouldSetCookie) {
      setCookie(LOCALE_COOKIE_NAME, locale, {
        path: '/',
        sameSite: 'lax',
        maxAge: 60 * 60 * 24 * 365,
        secure: false,
      });
    }

    return locale;
  }
);

type BeforeLoadArgs = {
  location: { pathname: string };
};

export const beforeRootLoad = async ({ location }: BeforeLoadArgs) => {
  if (location.pathname === '/') {
    const locale: AppLocale = await detectAndSetLocale();

    throw redirect({
      to: '/$locale',
      params: { locale },
      replace: true,
    });
  }
};
